module.exports = __webpack_public_path__ + "assets/img/fryer.c0f31b1a.png";